import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {saveAs} from 'file-saver/FileSaver';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {ConfigurationService, ProductsService} from '../../pages-services';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: false,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

    columns = [
        {key: 'id', title: 'ID'},
        {key: 'name', title: 'Name'},
        {key: 'description', title: 'Description'},
        {key: 'category', title: 'Category'},
        {key: 'subcategory', title: 'Subcategory'},
        {key: 'price', title: 'Price'},
        {key: 'width', title: 'ASSOCIATED WITH'}
    ];

    data = [];
    rows = [];
    selected = new Set();
    searchTerm = '';

    isUploading = false;
    isExporting = false;

    constructor(
        private route: ActivatedRoute,
        private productsService: ProductsService,
        private toasterService: ToasterService,
        private translateService: TranslateService,
        private configurationService: ConfigurationService
    ) {
        this.rows = this.data;
    }

    ngOnInit() {
        this.getList();
    }

    getList() {
        this.productsService.getList().subscribe(({variants}) => {
            this.data = variants;
            this.rows = this.data;
        });
    }

    saveFile() {
        this.isExporting = true;
        this.configurationService.getExport([]).subscribe(response => {
            this.saveToFileSystem(response);
        });
    }

    private async saveToFileSystem(response) {
        const fileContent = JSON.stringify(response, null, 2);
        const blob = new Blob([fileContent], {type: 'text/plain'});
        saveAs(blob, 'configurator-' + moment().format('YYYYMMDD-HHmm') + '.json');
        this.isExporting = false;
        let successMessage = await this.translateService.get('webpanel.products.export.success_message').toPromise();
        this.toasterService.pop('success', '', successMessage);
    }

    fileUpload({target: {files}}) {
        this.isUploading = true;
        const file = files[0];
        const reader = new FileReader();
        reader.onload = () => {
            const result = JSON.parse(reader.result);
            this.configurationService.uploadImport(result).subscribe(async (response) => {
                this.isUploading = false;
                if (response.success) {
                    let successMessage = await this.translateService.get('webpanel.products.import.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                } else {
                    let successMessage = await this.translateService.get('webpanel.products.import.error_message').toPromise();
                    this.toasterService.pop('error', '', successMessage);
                }
            });
        };
        reader.readAsText(file);
    }

    search() {
        this.rows = this.data.filter((row) =>
            this.searchTerm.length === 0 ||
            row.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            row.description.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            row.category.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            row.subcategory.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1
        );
    }

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/products/products.component.ts